import { useState } from "react";

import api from "shared/infra/services/api";

import {
  IGetOrganizationInfo,
  IOrganizationGroup,
} from "@Console/organizations/[organization_id]/types";
import { captureException, captureMessage } from "@sentry/nextjs";

export const useOrganizationService = () => {
  const [isOrganizationGroupsLoading, setIsOrganizationGroupsLoading] =
    useState(false);
  const [isRemovingGroupFromOrganization, setIsRemovingGroupFromOrganization] =
    useState(false);
  const [isOrganizationInfoLoading, setIsOrganizationInfoLoading] =
    useState(true);

  const getOrganizationGroups = async (
    organizationId: string,
  ): Promise<IOrganizationGroup[] | false> => {
    try {
      setIsOrganizationGroupsLoading(true);

      const { data } = await api.get(`/console/org/${organizationId}/groups`);

      return data?.data;
    } catch (error) {
      console.log("Erro (createOrganization): ", error);
      captureException(error);
      captureMessage("Erro (createOrganization)");
    } finally {
      setIsOrganizationGroupsLoading(false);
    }
  };

  const removeGroupFromOrganization = async ({
    organizationId,
    groupId,
  }): Promise<boolean> => {
    try {
      setIsRemovingGroupFromOrganization(true);

      await api.delete(
        `/console/org/${organizationId}/remove-group/${groupId}`,
      );

      return true;
    } catch (error) {
      console.log("Erro (removeGroupFromOrganization): ", error);
      captureException(error);
      captureMessage("Erro (removeGroupFromOrganization)");

      return false;
    } finally {
      setIsRemovingGroupFromOrganization(false);
    }
  };

  const getOrganizationInfo = async (
    organizationId: string,
    finishedCallback?: any,
  ): Promise<IGetOrganizationInfo | false> => {
    try {
      setIsOrganizationInfoLoading(true);

      const { data } = await api.get(`/console/org/${organizationId}`);

      return data?.data;
    } catch (error) {
      console.log("Erro (getOrganizationInfo): ", error);
      captureException(error);
      captureMessage("Erro (getOrganizationInfo)");

      return false;
    } finally {
      setIsOrganizationInfoLoading(false);

      if (!!finishedCallback) finishedCallback();
    }
  };

  return {
    isOrganizationGroupsLoading,
    getOrganizationGroups,

    isRemovingGroupFromOrganization,
    removeGroupFromOrganization,

    isOrganizationInfoLoading,
    getOrganizationInfo,
  };
};
